module.exports = __webpack_public_path__ + "4d3d0347a6786681e5f0f4cb42e95855.dcm";